import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startAppendPreviewPage = () =>
  produce((draft: Draft<State>) => {
    draft.appendPreviewPage.fetching = initialState.appendPreviewPage.fetching + 1;
  });

export const finishAppendPreviewPage = () =>
  produce((draft: Draft<State>) => {
    draft.appendPreviewPage.fetching = initialState.appendPreviewPage.fetching - 1;
  });
